export function getComparable(v) {
  if (v === null || v === undefined) return null;
  if (typeof v === 'number') return v;
  if (typeof v === 'boolean') return v ? 1 : 0;
  if (typeof v === 'string') {
    const trimmed = v.trim();
    if (trimmed === '') return '';
    const maybeNum = Number(trimmed.replace(/[$,]/g, ''));
    if (!Number.isNaN(maybeNum) && /^(\d|[-+])/.test(trimmed)) return maybeNum;
    const t = Date.parse(trimmed);
    if (!Number.isNaN(t) && /\d{4}-\d{2}-\d{2}/.test(trimmed)) return t;
    return trimmed.toLowerCase();
  }
  return v;
}

/** Returns a new sorted array; `conf` is `{ key, direction }` or nullish. */
export function sortRows(data, conf) {
  if (!Array.isArray(data)) return [];
  if (!conf || !conf.key) return data;
  const { key, direction } = conf;
  const dir = direction === 'desc' ? -1 : 1;
  return [...data].sort((a, b) => {
    const av = getComparable(a?.[key]);
    const bv = getComparable(b?.[key]);
    const aNull = av === null;
    const bNull = bv === null;
    if (aNull && bNull) return 0;
    if (aNull) return 1;
    if (bNull) return -1;
    if (typeof av === 'number' && typeof bv === 'number') {
      if (av === bv) return 0;
      return av > bv ? dir : -dir;
    }
    const as = String(av);
    const bs = String(bv);
    const cmp = as.localeCompare(bs, 'tr');
    return cmp * dir;
  });
}
